import { IResultsFilter } from '../../../pages/results';
import styles from './FilterSelect.module.scss';

export interface IFilterSelect {
  resultsFilterMethod: (x: IResultsFilter) => void;
  filterData: any[];
  sortBy: boolean;
  filterIndex: number;
  resultsFilterValue: IResultsFilter;
}

const FilterSelect = ({ filterData, sortBy, filterIndex, resultsFilterMethod, resultsFilterValue }: IFilterSelect) => {
  const getPropNameFromIndex = (): string => {
    switch (filterIndex) {
      case 0:
        return 'specialty';
      case 1:
        return 'acceptanceStatus';
      case 2:
        return 'sortType';
      default:
        return '';
    }
  };

  const propName: string = getPropNameFromIndex();

  return (
    <span>
      {sortBy ? <span className={styles.sortByText}>Sort By</span> : null}
      <select
        className={styles.filterSelect}
        onChange={(e) => {
          resultsFilterMethod({ ...resultsFilterValue, [propName]: e.target.value });
        }}
      >
        {filterData.map((x, i) => (
          <option key={`fdk-${x}-${filterIndex}-${i}`} value={x.value}>
            {x.name}
          </option>
        ))}
      </select>
    </span>
  );
};

export default FilterSelect;
